export default {
  GET_CURRENT_JOB: (state) => {
    return state.currentJob;
  },
};
